import * as React from "react";
import { Button, Dialog } from "@/components/ui";

interface Props {
  open: boolean;
  submittingPosted?: boolean;
  onClose: () => void;
  onSubmit: (posted: boolean) => void;
}

export const MarkAsDoneDialog: React.FC<Props> = ({ open, submittingPosted, onClose, onSubmit }) => {
  const busy = submittingPosted !== undefined;

  return (
    <Dialog
      open={open}
      onOpenChange={isOpen => !isOpen && !busy && onClose()}
      size="md"
      className="gap-0"
      showCloseButton={!busy}
    >
      <Dialog.Header>
        <Dialog.Title>Did you already post this video?</Dialog.Title>
      </Dialog.Header>
      <Dialog.Content className="text-sm text-slate-600">
        Either way, this project will move to Posted and any scheduled post for it will be canceled.
      </Dialog.Content>
      <Dialog.Footer className="gap-2">
        <Button variant="outline" onClick={() => onSubmit(false)} disabled={busy} loading={submittingPosted === false}>
          No, I'm not posting it
        </Button>
        <Button onClick={() => onSubmit(true)} disabled={busy} loading={submittingPosted === true}>
          Yes, I posted it
        </Button>
      </Dialog.Footer>
    </Dialog>
  );
};
